import React from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import withNotification from "@hooks/useNotification";
import { SvgCakeIcon } from "@routes/IconeSvg";
import "@css/pages/hoursPlanner/hoursPlanner.css";
import ModalIndex from "@Modals/layout/index";
import { defaultUserImage } from "@helpers/_constants";
import { Anniversary } from "@services/anniversary.service";

class CModalAddNoteAnniversary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      note: this.props.noteValue  || "",
      noteError: false
    };
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isOpen && this.props.isOpen) {
      this.setState({
        note: this.props.noteValue || "", 
        noteError: false
      });
    }
  }

  onChangeNote = (e) => {
    this.setState({
      note: e.target.value,
      noteError: false
    });
  };

  onClickSave = () => {
    if (!this.state.note || this.state.note.trim() === "") {
      this.setState({ noteError: true });
      this.props.showError("field_obligatory");
      return;
    }
    let noteData = {
      content: this.state.note,
      Employer: this.props.employe._id,
      type: this.props.noteType,
      Enterprise: localStorage.getItem("enterpriseId")
    };
    Anniversary.addNote(noteData)
      .then(() => {
        let message = "creation_action_success";
        if (this.props.noteValue) {
          message = "update_action_success";
        }
        this.props.showSuccess(message, { object: "note" });
      })
      .catch((err) => {
        let mode = "action_mode_add";
        if (this.props.noteValue) {
          mode = "action_mode_update";
        }
        this.props.showError("error_occured", { mode, object: "noteLower" });
        console.error(err);
      })
      .finally(() => this.props.onClickClose());
  };

  render() {
    const employe = this.props.employe;
    return (
      <ModalIndex  
        isOpen={this.props.isOpen}
        title={
          this.props.noteValue
            ? this.props.t("Editer la note")
            : this.props.t("Ajouter une note")
        }
        onClickClose={this.props.onClickClose}
        buttonOptions={{
          click: this.onClickSave,
          color: "green",
          title: this.props.t("Soumettre")
        }}
        buttonCancelOptions={{
          click: this.props.onClickClose,
          color: "outlined",
          title: this.props.t("Annuler")
        }}
      >
        <div className="modalContent !-arh-mt-12">
          <div className="modalHeader">
            <div className="d-flex flex-justify-center flex-wrap userInfo userInfo_modals">
              <div className="d-flex flex-justify-center headerPhoto">
                <div className="position_relative userImg">
                  <img
                    src={employe?.images?.location || defaultUserImage}
                    className="imgCircle"
                    alt="User_profile"
                  />
                </div>
              </div>
              <div className="titleDate semibold mb_bottom">
                <span className="username">{employe?.fullname}</span>
              </div>
              <span className="d-flex flex-align-center">
                {SvgCakeIcon()}{" "}
                <span className="anniversary_date regular">
                  {this.props.anniversaryDate}
                </span>
              </span>
            </div>
          </div>
          <div
            className={`items_notes notes_content ${
              this.state.noteError ? " field_invalid" : ""
            }`}
          >
            <span
              className={`regular arh-text-xs arh-mb-4 GreenThemeSelect ${
                this.state.noteError ? "error_label" : ""
              }`}
            >
              {this.props.t("Ajouter un commentaire")}
            </span>
            <textarea
              className={
                "regular notes_area GreenThemeSelect placeholder:arh-text-[#97a3a9]" +
                (this.state.noteError ? " area_invalid" : "")
              }
              placeholder={this.props.t("Vos notes")}
              onChange={this.onChangeNote}
              value={this.state.note.trim() === '' ? '' : this.state.note}
            ></textarea>
          </div>
        </div>
      </ModalIndex  >
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch
  };
};

export default connect(mapDispatchToProps)(
  withTranslation("pages.employés.anniversary")(
    withNotification(CModalAddNoteAnniversary)
  )
);
